import { Button } from "../../../../../components/Button/Button.tsx";
import { designerCanvasStore } from "../Designer/stores/designerCanvasStore.ts";

export const VideoPlaybackBar = () => {
  const { isVideoDisplayed, isVideoPlaying } = designerCanvasStore.useState();

  return isVideoDisplayed ? (
    <Button
      iconName={isVideoPlaying ? "Pause" : "Play"}
      size="md"
      variant="secondary"
      onClick={() => {
        designerCanvasStore.setIsVideoPlaying(!isVideoPlaying);
      }}
    />
  ) : null;
};
